import React, { useContext, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';

import { Context } from '../../context/provider';

import FilterFloatingButton from './components/FilterFloatingButton';
import StyledFilterModal from './filterModal.style';
import ViewSwitch from '../viewSwitch/viewSwitch';

const FilterModal = ({ children }) => {
  const { filter, setIsModalOpen } = useContext(Context);
  const modalRef = useRef(null);

  useEffect(() => {
    if (!modalRef.current) return;
    if (filter.isModalOpen) modalRef.current.showModal();
    else modalRef.current.close();
  }, [filter.isModalOpen]);

  useEffect(() => {
    if (modalRef.current) {
      modalRef.current.addEventListener('close', () => setIsModalOpen(false));
    }

    return () => {
      if (modalRef.current) {
        modalRef.current.removeEventListener('close', () => setIsModalOpen(false));
      }
    };
  }, []);

  return (
    <StyledFilterModal>
      <FilterFloatingButton />
      <ViewSwitch />

      <motion.dialog
        ref={modalRef}
        animate={{
          opacity: filter.isModalOpen ? 1 : 0
        }}
      >
        <FilterFloatingButton />

        <div className="filter-modal__content">{children}</div>
      </motion.dialog>
    </StyledFilterModal>
  );
};

FilterModal.propTypes = {
  children: PropTypes.node
};

export default FilterModal;
